<!--
 - Author : wanghongling.
 - Date   : 2019/5/29.
 - File   : jianCeEnergy.当日能耗监测
 -->

<template>
  <div class="jian-ce-energy">
    <layer title="当日能耗监测" width="410px" padding="15px 20px 5px">
      <div class="energyList">
        <div class="energyList-item1">
          <div class="energyList-item1-left">
            <dashboard id="water" v-if="isWaterObjShow" :dashboardObj="waterObj"></dashboard>
            <div class="p">
              <p>当日总耗水量(t)</p>
              <p>{{waterObj.value}}</p>
            </div>
          </div>
          <div class="energyList-item1-right">
            <dashboard id="electric" v-if="isElectricObj" :dashboardObj="electricObj"></dashboard>
            <div class="p">
              <p>当日总耗电量(kWh)</p>
              <p>{{electricObj.value}}</p>
            </div>
          </div>
        </div>
      </div>
    </layer>
  </div>
</template>

<script>
  export default {
    name: 'jianCeEnergy',
    data () {
      return {
        orgId: '',
        isWaterObjShow: true,
        waterObj: {
          width: '123px',
          height: '123px',
          value: 0,
          detail: '水(t)'
        },
        isElectricObj: true,
        electricObj: {
          width: '123px',
          height: '123px',
          value: 0,
          detail: '电(kw/h)'
        },
        timeNewsData: null,
        timeNewsData1: null
      }
    },
    props: {
      selectOrgId: {}
    },
    watch: {
      selectOrgId: {
        handler(cur) {
          this.orgId = cur
          this.getElectricToday()
          this.getWaterToday()
        },
        deep: true
      }
    },
    mounted () {
      this.orgId = this.$store.getters.userInfo.orgId
      this.getElectricToday()
      this.getWaterToday()
      this.dataFresh()
      this.getElecWaterData()
    },
    destroyed () {
      clearInterval(this.timeNewsData)
      this.timeNewsData = null
      clearTimeout(this.timeNewsData1)
      this.timeNewsData1 = null
    },
    methods: {
      /**
       * websocket监听今日用电、水数据
       * @author: whl
       * @createDate: 2019/06/04
       * @return {Object}
       */
      getElecWaterData () {
        window.getElecWaterData = e => {
          if (e.content.orgId === this.orgId) {
            this.electricObj.value = e.content.totalThreePowerFactor
            this.waterObj.value = e.content.totalAllFlow
          }
        }
      },
      /**
       * echart组件 赋值
       * @author: whl
       * @createDate: 2019/06/04
       * @return {Object}
       */
      valueUpdate () {
        let timestamp = 8000
        this.isWaterObjShow = false
        this.$nextTick(() => {
          this.isWaterObjShow = true
        }, 0)
        setTimeout(() => {
          this.isElectricObj = false
          this.$nextTick(() => {
            this.isElectricObj = true
          }, 0)
        }, timestamp * 2)
      },
      /**
       * 定时获取数据
       * @author: whl
       * @createDate: 2019/6/4
       * @return {Object}
       */
      dataFresh () {
        clearInterval(this.timeNewsData)
        this.timeNewsData1 = setTimeout(() => {
          this.valueUpdate()
        }, 8000)
        this.timeNewsData = setInterval(() => {
          this.valueUpdate()
        }, 24000)
      },
      /**
       * 获取当日耗电量
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      getElectricToday () {
        this.$request.deviceElectricTodayGet({orgId: this.orgId}).then(res => {
          if (!this.$utils.isEmptyObject(res)) {
            console.log('获取当日耗电量****', res)
            this.electricObj.value = res.totalThreePowerFactor
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 获取当日耗水量
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      getWaterToday () {
        this.$request.deviceWaterTodayGet({orgId: this.orgId}).then(res => {
          if (!this.$utils.isEmptyObject(res)) {
            console.log('获取当日耗水量****', res)
            this.waterObj.value = res.totalAllFlow
          }
        }).catch(e => {
          console.error(e)
        })
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';

  .jian-ce-energy {
    padding-bottom: 20px;
    overflow: hidden;

    .energyList {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;

      &-item {
        width: 100%;
        display: flex;
        margin-top: 30px;
        align-items: center;
        flex-wrap: wrap;
        position: relative;
        &-left {
          width: 130px;
        }

        &-right {
          display: flex;
          position: absolute;
          right: -15px;
          top: -65px;

          .airAQIBox1 {
            width: 128px;
            height: 250px;
          }

          .airAQIBox2 {
            width: 256px;
            height: 250px;
          }

          .airAQIBox3 {
            width: 0;
            height: 0;
          }
        }
      }
      &-item1 {
        width: 100%;
        display: flex;
        margin-top: 10px;
        align-items: center;
        position: relative;
        justify-content: space-around;
        &-left, &-right{
          text-align: center;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          .p{
            color: #00fffc;
            font-size: 17px;
            p:last-child{
              color: #fff;font-size: 32px;
              font-weight: bold;
            }
            padding-top: 15px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/jianCeEnergy.vue